const LitexpoLogo = ({ fill = "black" }) => {
  return (
    <svg
      width="80px"
      height="37px"
      viewBox="0 0 80 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>4DD043AF-C664-439B-A225-BEB9A68D6897</title>
      <g
        id="desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="1"
      >
        <g
          id="landing"
          transform="translate(-309, -2854)"
          fill={fill}
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(100, 2657)">
            <g id="Group-8-Copy-3" transform="translate(209, 150)">
              <g id="Group" transform="translate(0, 47)">
                <path
                  d="M0,0 L3.37018579,0.685433257 L3.37018579,30.7605766 L8.583294,29.9960884 L8.583294,34.5779794 L0,36.323619 L0,0 Z M10.0237336,2.03864704 L13.3939194,2.7240803 L13.3939194,33.5995039 L10.0237336,34.2849372 L10.0237336,2.03864704 Z M14.8344292,3.01715731 L24.2305451,4.92820431 L24.2305451,8.62242026 L21.2175801,8.18040701 L21.2175801,32.0082911 L17.8473943,32.6937243 L17.8473943,7.6862696 L14.8344292,7.2444301 L14.8344292,3.01715731 Z M25.6709672,5.22098597 L32.5898615,6.62816568 L32.5898615,9.84822514 L28.8826221,9.30456968 L28.8826221,16.5072657 L32.1933587,16.616379 L32.1933587,19.638019 L28.8826221,19.7473061 L28.8826221,27.0191535 L32.6493106,26.466637 L32.6493106,29.6941676 L25.6709672,31.1025635 L25.6709672,5.22098597 Z M67.5216496,5.79859163 C74.412836,5.79859163 80,11.3343556 80,18.1619311 C80,24.9902016 74.412836,30.5249231 67.5216496,30.5249231 C60.6304633,30.5249231 55.0432993,24.9902016 55.0432993,18.1619311 C55.0432993,11.3343556 60.6304633,5.79859163 67.5216496,5.79859163 Z M33.8385909,6.88221904 L37.7097977,7.66964196 L39.8141909,13.7516676 L41.6173054,8.46436231 L44.9638166,9.14493065 L41.4180892,18.1274944 L44.9892446,27.1734759 L41.6408043,27.8545655 L39.8141909,22.5026262 L37.6826159,28.6595369 L33.8091294,29.4473074 L38.3505854,18.1267994 L33.8385909,6.88221904 Z M45.985254,9.35207223 L49.9152084,10.1436651 C52.5246561,10.6708145 53.5614203,11.9073744 53.5614203,14.0677488 L53.5740467,18.5137695 C53.5740467,20.6565954 52.5372825,22.0983508 49.9278349,22.5622562 L49.1770926,22.6956942 L49.1770926,26.3218012 L45.985254,26.9709213 L45.985254,9.35207223 Z M67.5216496,9.57585881 C62.735032,9.57585881 58.854706,13.4194975 58.854706,18.1619311 C58.854706,22.904191 62.735032,26.7486984 67.5216496,26.7486984 C72.3082673,26.7486984 76.1884177,22.904191 76.1884177,18.1619311 C76.1884177,13.4194975 72.3082673,9.57585881 67.5216496,9.57585881 Z M49.1644661,12.27624 L49.1770926,20.4680795 L49.7668486,20.3631362 C50.3388928,20.261494 50.6249151,19.8919334 50.6249151,19.2721766 L50.6122887,13.3748444 C50.6122887,12.7728098 50.3441537,12.4499873 49.7721095,12.3657198 L49.1644661,12.27624 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LitexpoLogo;
